import { isDefined } from "@clipboard-health/util-ts";
import { type UseGetQueryOptions } from "@src/appV2/api";
import { useMemo } from "react";

import { type QualificationsResponse, SpecialQualifications } from "../types";
import { useGetQualifications } from "./useGetQualifications";

const EXCLUDED_QUALIFICATIONS = new Set<string>([SpecialQualifications.NURSE]);

/**
 * We don't want to show users the NURSE qualification.
 * However, we don't have an option to configure that on the model level.
 *
 * This hook filters out the NURSE qualification from the qualifications list.
 */
export function useWorkerVisibleQualifications(
  options: UseGetQueryOptions<QualificationsResponse> = {}
) {
  const queryData = useGetQualifications(
    {
      enabled: true,
    },
    options
  );

  const filteredData = useMemo(() => {
    if (!isDefined(queryData.data)) {
      return undefined;
    }

    return {
      data: queryData.data?.data.filter(
        (qualification) => !EXCLUDED_QUALIFICATIONS.has(qualification.attributes.name)
      ),
    };
  }, [queryData.data]);

  return {
    ...queryData,
    data: filteredData,
  };
}
